import { isNode } from "@p0security/shared/graph/types";
import { entireWorkspace } from "@p0security/shared/types/assessment/constants";
import { ResourceNode } from "@p0security/shared/types/assessment/data/index";
import { Descriptions, List } from "antd";
import { ScopeContext } from "components/Assessment/contexts/ScopeContext";
import { sortBy } from "lodash";
import { useContext } from "react";

import { IdentityCell, IdentityLink } from "../../cells/Identity";
import { NodeLink } from "../../cells/NodeLink";
import { Resource } from "../../cells/Resource";
import { NodeDescriptions } from "../NodeDescriptions";
import { DisplayList } from "../shared";
import { resourceLabels } from "./labels";

const { Item } = Descriptions;

export const ResourceNodeDisplay: React.FC<{
  node: ResourceNode;
}> = ({ node }) => {
  const { provider } = useContext(ScopeContext);
  const parent = node.parents.find((n) => n.type === "resource");
  return (
    <>
      <NodeDescriptions>
        <Item label="Resource">
          <Resource resource={node} />
        </Item>
        <Item label="Parent">
          {parent && isNode("resource")(parent) ? (
            <>
              {
                /* Handles an edge case where "entire workspace" is not represented in the graph */
                parent.data.service !== entireWorkspace.service && (
                  <>
                    <NodeLink node={parent} />
                    &nbsp;
                  </>
                )
              }
              <Resource resource={parent} />
            </>
          ) : (
            "(no parent)"
          )}
        </Item>
        <Item label="Children">
          {node.children.length ? (
            <DisplayList>
              {sortBy(node.children, (c) => c.key).map((c, ix) =>
                isNode("resource")(c) ? (
                  <List.Item key={ix}>
                    <NodeLink node={c} />
                    &nbsp;
                    <Resource resource={c} key={ix} />
                  </List.Item>
                ) : null
              )}
            </DisplayList>
          ) : (
            "(no child resources)"
          )}
        </Item>
        <Item label="Accessible by">
          {resourceLabels(node.data, provider).isGeneric ? (
            "(Select a service to view accessors)"
          ) : node.aggregates.identities.length ? (
            <DisplayList>
              {sortBy(node.aggregates.identities, ["type", "id"]).map(
                (p, ix) => (
                  <List.Item key={ix}>
                    <IdentityLink data={p} type="short" show="grant" />{" "}
                    <IdentityCell identity={p} />
                  </List.Item>
                )
              )}
            </DisplayList>
          ) : (
            "(Not accessible)"
          )}
        </Item>
      </NodeDescriptions>
    </>
  );
};
